import React, { ReactNode, useEffect, useCallback, useState } from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import { useAppDispatch } from '../store';
import LicenseBanner from '../components/shared/Licenses/LicenseBanner';
import LicenseOverlay from '../components/shared/Licenses/LicenseOverlay';
import NoSeatGate from '../components/shared/Licenses/NoSeatGate';

import { getPreferences, userInformation } from '../store/actions/DataAction';
import { initializeUserPreferencesIfNeeded } from '../store/actions/SettingsActions';
import { getAiModels, getUserID, getUserType } from '../store/actions/ChatAction';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { LayoutContext } from '../contexts/LayoutContext';
import { BreadcrumbsProvider } from '../contexts/BreadcrumbsContext';
import NotificationsSidepanel from '../components/Notifications/NotificationsSidepanel';

interface PrivateLayoutProps {
  children: ReactNode;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const userId = getUserID();
  const userType = getUserType();
  const history = useHistory();
  const [isContentScrollable, setIsContentScrollable] = useState<boolean>(true);

  useEffect(() => {
    if (userType) {
      const fetchData = async () => {
        await Promise.all([
          dispatch(getAiModels()),
          dispatch(userInformation()),
          dispatch(getPreferences()),
          dispatch(initializeUserPreferencesIfNeeded() as any),
        ]);
      };
      fetchData();
    }
  }, [userId, userType, dispatch]);

  const storeSession = useCallback((data: any) => {
    const { session_id } = data;
    if (session_id) {
      sessionStorage.setItem('session_id', session_id);
    }
  }, []);

  const sessionSignOut = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    history.push('/');
  }, [history]);

  // Socket listeners removed - legacy code


  return (
    <LayoutContext.Provider value={{ isContentScrollable, setIsContentScrollable }}>
      <BreadcrumbsProvider>
        <div
          className={`
            flex flex-col min-h-screen
            bg-background-light text-text-light
            dark:bg-background-dark dark:text-text-dark
            transition-colors duration-200
          `}
        >
          <div
            className={`
              flex-1 flex flex-row p-0 relative overflow-hidden
              transition-all duration-200
            `}
          >
            <Sidebar />
            <main
              className={clsx(
                'flex-1',
                'custom-scrollbar-main relative z-0',
                isContentScrollable ? 'overflow-y-auto max-h-[calc(100vh)]' : 'overflow-hidden'
              )}
            >
              <LicenseBanner />
              <NoSeatGate>
                <LicenseOverlay>
                  {children}
                </LicenseOverlay>
              </NoSeatGate>
            </main>
            <NotificationsSidepanel />
          </div>
        </div>
      </BreadcrumbsProvider>
    </LayoutContext.Provider>
  );
};

export default PrivateLayout;
